import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-products.action';
import {
  LoadEcommerceProduct,
  LoadEcommerceProductDropdowns,
  LoadEcommerceProductVariations
} from '../actions/ecommerce-products.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";

@Injectable()
export class EcommerceProductEffect {

  loadEcommerceProduct$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_PRODUCT),
    mergeMap((action: LoadEcommerceProduct) => {
      const {websiteId, id} = action.payload;
      return this._ecommerceService.getProductById(websiteId, id)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceProductSuccess({
                websiteId,
                product: response.data.dataKey
              });
            }
            return new EcommerceActions.LoadEcommerceProductFails({websiteId});
          })
        );
    })
  ));
  loadEcommerceProductVariations$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_PRODUCT_VARIATIONS),
    mergeMap((action: LoadEcommerceProductVariations) => {
      const {websiteId, id} = action.payload;
      return this._ecommerceService.getVariations(websiteId, id)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceProductVariationsSuccess({
                websiteId,
                variations: response.data.dataKey
              });
            }
            return new EcommerceActions.LoadEcommerceProductVariationsFails({websiteId});
          })
        );
    })
  ));
  loadEcommerceProductDropdowns$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_PRODUCT_DROPDOWNS),
    mergeMap((action: LoadEcommerceProductDropdowns) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getProductAutocompleteLists(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceProductDropdownsSuccess({
                websiteId,
                dropdowns: response.data
              });
            }
            return new EcommerceActions.LoadEcommerceProductDropdownsFails({websiteId});
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
    private _ordersService: EcommerceService,
  ) {
  }

}
